import React from 'react';

const PrepProgress = () => {
  return (
    <div style={styles.container}>
      <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" rel="stylesheet" />
      
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.titleSection}>
            <h1 style={styles.title}>Prep Progress</h1>
            <p style={styles.subtitle}>Track your preparation progress and performance</p>
          </div>
        </div>
      </div>

      <div style={styles.divider}></div>

      <div style={styles.section}>
        <div style={styles.content}>
          <div style={styles.statsGrid}>
            <div style={styles.statCard}>
              <div style={styles.statIcon}>
                <i className="fas fa-check-circle" style={{color: '#28a745'}}></i>
              </div>
              <div style={styles.statContent}>
                <div style={styles.statValue}>75%</div>
                <div style={styles.statLabel}>Completion Rate</div>
              </div>
            </div>
            
            <div style={styles.statCard}>
              <div style={styles.statIcon}>
                <i className="fas fa-clock" style={{color: '#ffc107'}}></i>
              </div>
              <div style={styles.statContent}>
                <div style={styles.statValue}>24h</div>
                <div style={styles.statLabel}>Study Time</div>
              </div>
            </div>
            
            <div style={styles.statCard}>
              <div style={styles.statIcon}>
                <i className="fas fa-target" style={{color: '#dc3545'}}></i>
              </div>
              <div style={styles.statContent}>
                <div style={styles.statValue}>85%</div>
                <div style={styles.statLabel}>Accuracy</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    padding: '20px',
    fontFamily: '"Open Sans", sans-serif',
  },
  header: {
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    padding: '30px',
    marginBottom: '25px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
    border: '1px solid #e0e0e0'
  },
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    maxWidth: '1200px',
    margin: '0 auto'
  },
  titleSection: {
    flex: 1
  },
  title: {
    fontSize: '32px',
    fontWeight: '600',
    margin: '0 0 8px 0',
    color: '#2c5aa0',
    fontFamily: '"Open Sans", sans-serif',
    letterSpacing: '0px',
    lineHeight: '1.2'
  },
  subtitle: {
    fontSize: '16px',
    margin: '0',
    color: '#666666',
    fontFamily: '"Open Sans", sans-serif',
    letterSpacing: '0.25px',
    lineHeight: '1.5'
  },
  divider: {
    height: '1px',
    backgroundColor: '#e0e0e0',
    margin: '20px 0',
    maxWidth: '1200px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  section: {
    maxWidth: '1200px',
    margin: '0 auto 30px auto'
  },
  content: {
    maxWidth: '800px',
    margin: '0 auto'
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
  },
  statCard: {
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    padding: '24px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    border: '1px solid #e0e0e0',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  statIcon: {
    fontSize: '32px',
  },
  statContent: {
    flex: 1,
  },
  statValue: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#333333',
    marginBottom: '4px',
    fontFamily: '"Open Sans", sans-serif',
  },
  statLabel: {
    fontSize: '14px',
    color: '#666666',
    fontWeight: '500',
    fontFamily: '"Open Sans", sans-serif',
  },
};

export default PrepProgress;